const capitalize = (s: unknown): string => {
  if (!s) {
    return '';
  }
  const arr = String(s).trim().split(' ');
  return arr.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

export const capitalizeFirstLetterOfEachWord = (s: string): string => {
  return s
    .replaceAll('-', ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default capitalize;
